import React, { Component } from 'react';
import  ReactDOM from 'react-dom'

import  "./bbutil"

class BBIFrame extends Component {
  state = {
    imgViz: false
  }
   
  static htmln = 0;
 static scrolling="no";

 
  onClick = (uri) => {
    var me=this;
    console.log("publisch object ",uri);
    this.state.selection=uri;
    var pvar= me.props.publishVariable;
    if (pvar!=null)
    {
      me.props.publish(pvar,uri);
    }
  
  }

  getUrl()
  {

    return "";
  }

  componentDidMount() {
   
    this.mounted=true;

   // this.updateMe();
    
  
   
 }

shouldComponentUpdate_notused(arg)
{
  if (this.mounted)
  {
    if (this.iface!=null)
    {
        try
        {
            if (this.iface.afterIntegration!=null)
            {
               // this.iface.afterIntegration();
            }
        }
        catch(e){
          console.log(e);
        }
       
         try{
        //this.iface.setBeginSparqlResults(this.props.data,this.props.query);
      }
      catch(e){
        console.log(e);
      }
     //   this.setSelection();
    
    
    
    }
  
    return false;
  }
  return true;
}


updateMe()
{
 //console.log("update me "+this.getUrl());
  try
  {
    // voor initialisatie van iframes
    if ((this.mounted==true) && (this.iface!=null) )
  {
    var me=this;
    me.iface.me=me;
    try
    {
         if (me.iface.afterIntegration!=null)
         {
            me.iface.afterIntegration();
         }
    }
    catch(e){
      console.log(e);
    }

   // console.log("iframe setting sparl reustls ",this.getUrl());
    
    me.iface.setBeginSparqlResults(me.props.data,me.props.query);
  
    
    var iframe=ReactDOM.findDOMNode(this);
    var div=ReactDOM.findDOMNode(this).parentNode;
    
    div.setAttribute("style","position:relative;"); 
    
    if (me.iface.widget==null)
    {
           
          me.iface.widget={sendEvent:function(e,arg)
          {
           
            var pvar= me.props.publishVariable;
             if (pvar!=null)
             {
             
               me.onClick(arg);
             }
            
          
        
        },test:function(){console.log("test");} };
    }
    
  

}
}
catch(e)
{
  console.log(e);
}
}

setSelection()
{
 // console.log("iframe setSelection ",this.getUrl());
try{
  var pvar= this.props.subscribeVariable;
  if ((pvar!=null) && (this.props.pubsub!=null) )
  {
   
    var selectionValue =this.props.pubsub[pvar];
     
    if ((selectionValue!=null) && (this.state!=null) && (this.state.selection!=selectionValue))
    {
      if (this.iface!=null)
      {
        this.iface.selectUri(selectionValue);
        this.state.selection=selectionValue;
       // this.iface.setBeginSparqlResults(me.props.data,me.props.query);
      }
    }
  }
}catch(e)
{
  console.log("error met selection ",e);
}

}

  render() {
    
    //console.log("iframe render ",this.getUrl());



    var me=this;
    try
    {
        me.iface.afterIntegration();
    }
    catch(e){}
      
    try
    {
        me.iface.render();
    }
    catch(e){}
      
     
      
    this.setSelection();
    this.message="";
    if (this.props.cachedResults)
    {
       
          try
        {
          
           me.iface.setBeginSparqlResults(this.props.data,this.props.sparql);
          
        }
        catch(e){}
      
    }
    
     // return null;

    var height="100%";
    
    try{
    if (this.props.height!=null) {height=this.props.height;}
    }
    catch(e){}
  

  
    if (this.htmlid == null) {
      BBIFrame.htmln++;
      this.htmlid = "iframe" + BBIFrame.htmln;
    }
    if (window.top.Singleton.getInstance().iframes==null)         {window.top.Singleton.getInstance().iframes={};  }

    
    window.top.Singleton.getInstance().iframes[this.htmlid]=function(arg){me.iface=arg;me.updateMe();}
    

    this.getUrl(); // setting BBIFrame...
      
    return (
      
      <iframe id={this.htmlid}  width="100%" height={height} frameBorder="0" scrolling={BBIFrame.scrolling} 
      src={this.getUrl()}/>
    
    )
   
  } 

  
}
export default BBIFrame;